import type React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "../store";
import { fetchUserData } from "../store/features/userSlice";

const TempPasswordRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchUserData());
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      navigate("/reset-password");
    }
  }, [user, navigate]);

  return <div>TempPasswordRedirect</div>;
};

export default TempPasswordRedirect;
